import { TravelDates } from 'types/legacy/backendInformation';
import { Iata } from 'types/Search/airport';
import { AirportValue } from 'types/Search/filter';
import { DestinationValue, DurationValue, Search } from 'types/Search/form';
import { Occupancy } from 'types/Search/form';

import { FormType } from '../Datepicker/types';

export enum ChangedHighlightType {
    TravellerOrRoom = 'travellerOrRoom',
    TravelDate = 'travelDate',
    Days = 'days',
    None = 'none',
}
export interface Highlight {
    travellerOrRoom: boolean;
    travelDate: boolean;
    days: boolean;
}
export interface HighlightData {
    changedInfo: Highlight;
    openType: ChangedHighlightType;
    showTooltip: boolean;
}
export interface ChangedFilterMapping {
    dataKey: keyof Highlight;
    fieldStack: string[];
}

export interface FormProps {
    formType: FormType;
    travelDates: TravelDates | null;
    onHotelTabClick?: () => void;
    onSubmit?: () => void;
    withToggle?: boolean;
}
export interface InitialProps extends FormProps {
    initialValue?: {
        destination?: DestinationValue;
        airport?: AirportValue<Iata>;
        duration?: DurationValue;
        departureDate?: Date;
        returnDate?: Date;
        occupancy?: Occupancy;
    };
}
export interface StandAloneProps extends FormProps {
    initialValue?: Search;
}
